
import { useState, useRef } from 'react';
import ServiceRepair from './component/ServiceRepair';
import SelectAppointment from './component/SelectAppointment';
import useOutsideClick from './hooks/useOutsideClick';
import FreeEstimate from './component/FreeEstimate';
import MainContent from './component/MainContent';
import { SpinnerComponent } from 'react-element-spinner';
import {
  buildAcuityRedirectUrl,
  getPrefilledPostalCode,
  isValidCanadianPostalCode,
  normalizePostalCode,
} from './utils/acuityParams';


function App() {

  const [isFreeEstimateActive, setIsFreeEstimateActive] = useState(false);
    const [postalCode, setPostalCode] = useState(() =>
      getPrefilledPostalCode(window.location.search)
    );
    const [validationError, setValidationError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const ref = useRef();
    
    useOutsideClick(ref, () => setIsFreeEstimateActive(false));

    const onKeyPress=(event)=>{ if (event.key === "Enter") { handleClickButton() } };

    const handleInputChange=(e)=>{
        const value = normalizePostalCode(e.target.value);
        setPostalCode(value);
        if(isValidCanadianPostalCode(value)){
        setValidationError("");
        }else{setValidationError("invalid postal code");}

    }

    const handleClickButton = async()=>{
      if(!isValidCanadianPostalCode(postalCode)){
        setValidationError("invalid postal code");
        return;
      }

      setIsLoading(true);
      setValidationError("");

      try {
        const options = { mode:'cors',method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ "postalCode":postalCode }) };
        const res = await fetch('https://wxcvcscd4i.execute-api.ca-central-1.amazonaws.com/dev/getAsCalendarByPostalCode', options) ;

        if(!res.ok){
          throw new Error(`Scheduling API returned ${res.status}`);
        }

        const {url, message} = await res.json();
        if(message !== ""){
          setValidationError(message);
        }else{
          window.location.href = buildAcuityRedirectUrl(
            url,
            window.location.search,
            postalCode
          );
        }
      } catch (error) {
        console.error("Unable to load appointment availability", error);
        setValidationError("Unable to load appointments right now. Please try again.");
      } finally {
        setIsLoading(false);
      }
    }

  return (
    <>
        {/* <img src={logo} className="App-logo" alt="logo" /> */}
        <MainContent>
                <div ref={ref}>
                    <FreeEstimate cursor={isFreeEstimateActive} onClick={() => setIsFreeEstimateActive(true)} >
                        <SelectAppointment
                            display={isFreeEstimateActive}
                            inputOnChange={handleInputChange}
                            onClickButton={handleClickButton}
                            onKeyPress={onKeyPress}
                            validationError={validationError}
                            value={postalCode}
                        />
                        
                    </FreeEstimate>
                </div>
                <ServiceRepair display={!isFreeEstimateActive} />
            </MainContent>
            <SpinnerComponent loading={isLoading} position="global" />
    </>
  );
}

export default App;
